<div [ngClass]="{'darkMode': darkModeService.darkMode}">

    <mat-form-field>
      <mat-label>Filter name</mat-label>
      <input matInput (keyup)="applyFilter($event)">
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort>
        <caption style="display:none;">Users</caption>
        <ng-container matColumnDef="name">
          <th scope="col" mat-header-cell *matHeaderCellDef> Name </th>
          <td mat-cell *matCellDef="let nuuma" > {{nuuma.name}} </td>
        </ng-container>

        <ng-container matColumnDef="mail">
          <th scope="col" mat-header-cell *matHeaderCellDef> Mail </th>
          <td mat-cell *matCellDef="let nuuma" style="min-width: 100px;">
            <div *ngIf="nuuma.mail != null">{{nuuma.mail}}
              <mat-icon *ngIf="nuuma.mail.includes('3p.')" class="alert" matTooltip="{{ 'WARNING.EMAIL_3P' | translate }}">notification_important</mat-icon>
            </div>
            <div *ngIf="nuuma.mail == null"><mat-icon class="alert" matTooltip="{{ 'WARNING.EMAIL' | translate }}">warning</mat-icon></div>
          </td>
        </ng-container>

        <ng-container matColumnDef="group">
            <th scope="col" mat-header-cell *matHeaderCellDef> Role </th>
            <td mat-cell *matCellDef="let nuuma">
                <mat-form-field appearance="fill">
                  <mat-select [(value)]="nuuma.role"  (selectionChange)=changeRole(nuuma)>
                    <mat-option value="admin">Admin</mat-option>
                    <mat-option value="user">User</mat-option>
                  </mat-select>
                </mat-form-field>
            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th scope="col" mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let nuuma">
              <button
                  mat-button
                  matSuffix
                  mat-icon-button
                  (click)= "remove(nuuma)"
                  aria-label="Clear">
                  <mat-icon>delete</mat-icon>
              </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="addUser" >
          <td mat-footer-cell *matFooterCellDef>
            <input
              class= "input"
              placeholder="{{ 'ORG.NUUMA' | translate }}"
              matInput
              #userInput
              pattern="[a-zA-Z0-9-_.@]*"
              [formControl]="userCtrl"
              [matAutocomplete]="autoNuumas"
              >
            <mat-error *ngIf="!userCtrl.pristine && userCtrl.errors">
              There are spaces or characters not allowed
            </mat-error>
            <mat-autocomplete #autoNuumas="matAutocomplete" (optionSelected)="selected($event)">
              <mat-option disabled class="loading" *ngIf="(loading) && (!userCtrl.errors)">
                  <mat-spinner diameter="35"></mat-spinner>
              </mat-option>
              <mat-optgroup label="{{ 'ORG_ADMIN.USERS' | translate }}" *ngIf="(filteredNuumas) && (!userCtrl.errors)">
                <mat-option *ngFor="let nuuma of filteredNuumas | async" [value]=" nuuma">
                  {{ nuuma }}
                </mat-option>
              </mat-optgroup>
              <mat-option disabled *ngIf="notResults && (!userCtrl.errors)">
                Not results
              </mat-option>
            </mat-autocomplete>
          </td>
        </ng-container>

        <ng-container matColumnDef="addRole">
          <td mat-footer-cell *matFooterCellDef>

          </td>
        </ng-container>

        <ng-container matColumnDef="updateTable">
          <td mat-footer-cell *matFooterCellDef colspan="2">

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns; let i=index;"></tr>
        <tr mat-footer-row *matFooterRowDef="['addUser', 'addRole', 'updateTable']"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

    <div *ngIf="organization.isDuplicatedUser"><p class="warning">{{ 'ALERT.NUUMA_DUPLICATE' | translate }}</p></div>
    <div *ngIf="!(organization.atLeastOneAdmin )" class="alert">{{ ("ORG_ADMIN.ADMIN_NOT_EMPTY"  | translate) }}</div>
    <br/>
</div>

<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" class="confirm">
  <p>{{ new ? ("ORG_ADMIN.SURE_CREATE" | translate) : ("ORG_ADMIN.SURE_UPDATE"  | translate) }}</p>
  <a routerLink="/v1/status"><button mat-raised-button color="secondary" type="button" *ngIf="new">
      {{ "ORG_ADMIN.CANCEL" | translate }}
    </button></a>
   <button [disabled]="(myForm && !myForm.valid) || !(organization.atLeastOneAdmin && !disabled)" mat-raised-button color="secondary" (click)="confirmNewOrg()" type="button">
    {{ new ? ("ORG_ADMIN.CREATE" | translate ): ("ORG_ADMIN.UPDATE"  | translate) }}
    {{ disabled ? " - " + ("ORG_ADMIN.WAIT" | translate ) + counter + ("ORG_ADMIN.SECONDS" | translate ) : '' }}
  </button>
</div>

<mat-divider></mat-divider>

<app-org-urls-step [organization]="organization"></app-org-urls-step>
<app-org-acr-step *ngIf="!new" [organization]="organization"></app-org-acr-step>
